// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aee1dd8c","105":"90accbe3","145":"41b8d1bb","190":"8c2b7cd4","496":"a93d752e","613":"4020565a","906":"5df8c89a","948":"66518d8e","969":"daed3506"}[chunkId] + ".chunk.js";
};